// client/src/components/admin/result/RejectedResultsSummary.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function RejectedResultsSummary({ interactive = false }) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  // 거절된 결과물 목록 조회 (최대 5개)
  const fetchRejectedResults = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/results/rejected-list?limit=100`, {
        credentials: 'include'
      });
      const data = await res.json();
      
      if (data.ok) {
        const list = data.results || [];
        setCount(list.length);
        setResults(list.slice(0, 5)); // 최대 5개만
      }
    } catch (error) {
      console.error('거절 건 목록 조회 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRejectedResults();
  }, []);

  // 날짜 포맷팅
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
  };

  return (
    <div className="rejected-results-summary">
      {/* 헤더 */}
      <div className="rejected-results-summary__header">
        <h3 className="rejected-results-summary__title">
          결과물 거절 건 처리
        </h3>
        {count > 0 && (
          <span className="rejected-results-summary__badge">
            {count}
          </span>
        )}
      </div>

      {/* 로딩 */}
      {loading && (
        <div className="rejected-results-summary__loading">
          로딩 중...
        </div>
      )}

      {/* 목록 */}
      {!loading && results.length === 0 && (
        <div className="rejected-results-summary__empty">
          처리할 거절 건이 없습니다.
        </div>
      )}

      {!loading && results.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {results.map((result) => (
            <div
              key={result.applicationId}
              style={{
                padding: 16,
                background: '#f9fafb',
                borderRadius: 8,
                border: '1px solid #e5e7eb'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ 
                    fontSize: 14, 
                    fontWeight: 600, 
                    color: '#111827',
                    marginBottom: 4
                  }}>
                    Project No: {result.projectNumber || 'N/A'}
                  </div>
                  <div style={{ fontSize: 12, color: '#6b7280' }}>
                    광고주: {result.marketerName || '알 수 없음'}
                  </div>
                  <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
                    인플루언서: {result.influencerName} ({result.influencerUserId})
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 4 }}>
                    거절일
                  </div>
                  <div style={{ fontSize: 12, color: '#4b5563', fontWeight: 600 }}>
                    {formatDate(result.rejectedAt)}
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          {count > 5 && (
            <div style={{ textAlign: 'center', fontSize: 12, color: '#6b7280', marginTop: 8 }}>
              외 {count - 5}건 더 있습니다
            </div>
          )}
        </div>
      )}
    </div>
  );
}

